import { AccountType } from './account-type.enum';

/**
 * Login API user object (`POST /auth/login` → `data.user`).
 * Role routing uses `account_type` (`ADMIN` | `MAKER` | `CHECKER`); `role` may be null.
 */
export interface TenantUser {
  id: string;
  created_at: string;
  updated_at: string;
  email: string;
  account_type: AccountType | string;
  status: string;
  is_active: boolean;
  is_deleted: boolean;
  session_version: number;
  locked_until: string | null;
  failed_login_attempts: number;
  last_login_at: string | null;
  last_login_ip: string | null;
  reset_password_token: string | null;
  reset_password_token_expiry: string | null;
  role: string | null;
  first_name: string | null;
  last_name: string | null;
  display_name: string | null;
  profile_image: string | null;
  is_email_verified: boolean;
  phone: string | null;
  workspace_id: string | null;
  display_id: number;
  employee_id: string | null;
}

export interface LoginRequest {
  email: string;
  password: string;
  rememberMe?: boolean;
}

export interface LoginResponseData {
  accessToken: string;
  refreshToken: string;
  user: TenantUser;
  rememberMe?: boolean;
}

/** Wrapper returned by `POST /auth/login` (typically `statusCode` 201). */
export interface LoginResponse {
  statusCode: number;
  status: boolean;
  message: string;
  timestamp: string;
  path: string;
  data: LoginResponseData;
}

export function isLoginSuccessResponse(response: LoginResponse): boolean {
  return (
    response.status === true &&
    (response.statusCode === 200 || response.statusCode === 201)
  );
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface RefreshTokenResponse {
  statusCode: number;
  status: boolean;
  message: string;
  timestamp: string;
  path: string;
  data: {
    accessToken: string;
    refreshToken: string;
  };
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export interface ChangePasswordRequest {
  newPassword: string;
}
